// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5d-0";
export var eligibilityCardNotEligible = "_5d-1";